import React from 'react'

const NotFound = () => {
    return (
        <div className='text-center'>404 NotFound</div>
    )
}

export default NotFound